import { Card, Row, Col, Typography, Skeleton } from "antd";
import { FaUsers, FaClock, FaUserTimes } from "react-icons/fa";
import { FaUserClock, FaUserCheck } from "react-icons/fa6";

const { Text } = Typography;

export function ParticipantesCharts({
  metricas,
  metricasCargadas = true // 🔥 NUEVO: Prop para estado de carga
}) {
  // 🔥 USAR MÉTRICAS DEL BACKEND CON VALORES POR DEFECTO
  const {
    total_participantes = 0,
    total_en_proceso = 0,
    total_verificados = 0,
    total_no_verificados = 0,
    total_no_continua = 0
  } = metricas || {};

  // 🔥 SKELETON MIENTRAS CARGA
  if (!metricasCargadas) {
    return (
      <Row gutter={[16, 16]} style={{ marginBottom: 15, display: "flex", flexWrap: "wrap" }}>
        {[1, 2, 3, 4, 5].map((item) => (
          <Col key={item} xs={24} sm={12} md={8} lg flex="20%">
            <Card style={{ borderRadius: 12 }}>
              <Skeleton active paragraph={{ rows: 2 }} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 15, display: "flex", flexWrap: "wrap" }}>
      <Col xs={24} sm={12} md={8} lg flex="20%">
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUsers style={{ color: "#0968C6", fontSize: 25, marginRight: 10 }} />
            <Text type="secondary">Total Participantes</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {total_participantes}
            </Text>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg flex="20%">
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaClock style={{ color: "#419df8", fontSize: 25, marginRight: 10 }} />
            <Text>En Proceso</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {total_en_proceso}
            </Text>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg flex="20%">
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserCheck style={{ color: "#20ac00", fontSize: 25, marginRight: 10 }} />
            <Text>Verificados</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {total_verificados}
            </Text>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg flex="20%">
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserClock style={{ color: "#838383ff", fontSize: 25, marginRight: 10 }} />
            <Text>No Verificado</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {total_no_verificados}
            </Text>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8} lg flex="20%">
        <Card hoverable style={{ borderRadius: 12 }}>
          <div style={{ textAlign: "center" }}>
            <FaUserTimes style={{ color: "#d62828", fontSize: 25, marginRight: 10 }} />
            <Text>No Continúa</Text>
            <Text style={{ display: "block", fontSize: 30, fontWeight: "bold" }}>
              {total_no_continua}
            </Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
}